import React, { useState } from 'react';
import { setFocus } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import GeneralButton from '../helpers/GeneralButton';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

const PreOxygenateOptionsUI = (props: UIProperties<PreOxygenateOptionsUIConfig>) => {
	const [selection, setSelection] = useState(0);
	const [showBVMPrompt, setShowBVMPrompt] = useState(false);
	const [show100Prompt, setShow100Prompt] = useState(false);
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%',
			pointerEvents: 'all'
		}}>
			{!showBVMPrompt ? <div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '1000px'
			}}>
				<img style={{
					width: '100%'
				}} src="./assets/images/Toolbag/bg.png" />
				<div style={{
					position: 'absolute',
					top: '43px',
					left: '50%',
					width: '100%',
					transform: 'translate(-50%, 0)'
				}}>
					<p className='title-font' style={{
						textAlign: 'center',
						margin: '0',
						fontSize: '40pt',
						fontWeight: 'normal'
					}} tabIndex={0} id="pre-oxygenate-header">Pre-Oxygenate Options</p>
				</div>
				<GeneralButton parameters= {{
					top: '27px',
					left: '884px',
					width: '90px',
					ariaLbl: 'Close',
					srcIdle: "./assets/images/general/buttons/button_close_window_main.png",
					srcHighlight: "./assets/images/general/buttons/button_close_window_down.png",
					srcDisabled: null,
					highlightOnHover: false,
					onClicked: () => {
						props.parameters.onCloseClicked();
					}
				}}/>
				<div style={{
					position: 'absolute',
					top: '135px',
					left: '58px',
					width: '886px',
					height: '547px'
				}}>
					<div style={{
						position: 'absolute',
						top: '10px',
						left: '50%',
						width: '100%',
						transform: 'translate(-50%, 0)'
					}}>
						<p className='title-font' style={{
							textAlign: 'center',
							margin: '0',
							fontSize: '14pt',
							fontWeight: 'normal'
						}} tabIndex={0}>Please select ONE of the following options.</p>
						<p className='title-font' style={{
							textAlign: 'center',
							margin: '0',
							fontSize: '14pt',
							fontWeight: 'normal'
						}}  tabIndex={0}>Nasal oxygenation increases your safe apnea time.</p>
					</div>

					<CustomPreOxygenateButton 
                        position={{
                            type: 'absolute',
                            left: '60px',
                            top: '80px'
                        }}
						ariaLbl= 'High Flow Nasal Oxygen'
						sideImgUrl={"./assets/images/pre-oxygenate/cannula.png"}
						sideImgWidth={"130px"}
                        isClicked={selection === 0}
						isLargeBg={true}
                        text="High Flow Nasal Oxygen"
                        onClicked={() => {
                            setSelection(0);
                        }}
					/>
					<CustomPreOxygenateButton 
                        position={{
                            type: 'absolute',
                            left: '520px',
                            top: '80px'
                        }}
						ariaLbl= 'Nasal Non invasive positive Pressure'
						sideImgUrl={"./assets/images/pre-oxygenate/nasal.png"}
						sideImgWidth={"130px"}
                        isClicked={selection === 1}
						isLargeBg={true}
                        text="Nasal Noninvasive Positive Pressure"
                        onClicked={() => {
                            setSelection(1);
                        }}
					/>

					<div style={{
						position: 'absolute',
						left: '50%',
						top: '300px',
						transform: 'translate(-50%, 0)',
						width: '740px',
						height: '2px',
						backgroundColor: 'rgb(182, 182, 182)'
					}}></div>
					<CustomPreOxygenateButton 
                        position={{
                            type: 'absolute',
                            left: '160px',
                            top: '344px'
                        }}
						ariaLbl= '100% non rebreather mask'
						sideImgUrl={"./assets/images/pre-oxygenate/mask.png"}
						sideImgWidth={"90px"}
                        isClicked={selection === 2}
						isLargeBg={false}
                        text="100% Non-Rebreather Mask"
                        onClicked={() => {
                            setSelection(2);
                        }}
					/>
					<CustomPreOxygenateButton 
                        position={{
                            type: 'absolute',
                            left: '480px',
                            top: '344px'
                        }}
						ariaLbl= 'B V M'
						sideImgUrl={"./assets/images/pre-oxygenate/bvm.png"}
						sideImgWidth={"90px"}
                        isClicked={selection === 3}
						isLargeBg={false}
                        text="BVM"
                        onClicked={() => {
                            setSelection(3);
                        }}
					/>
					<div style={{
						position: 'absolute',
						bottom: '-37px',
						width: '190px',
						height: '75px',
						left: '50%',
						transform: 'translate(-50%)'
					}}>
						<GeneralButtonWithText parameters={{
							text: '',
							top: '0',
							id: 'pre-oxygenate-done',
							ariaLbl: 'Done',
							left: '0',
							width: '190px',
							srcIdle: "./assets/images/Toolbag/done_btn.jpg",
							srcHighlight: "./assets/images/Toolbag/done_btn.jpg",
							srcDisabled: "./assets/images/Toolbag/done_btn.jpg",
							isDisabled: false,
							customImgStyle: {
							},
							customButtonStyle: {
							},
							customTextStyle: {
								fontSize: '10pt'
							},
							onClicked: () => {
								if(selection === 3) {
									setShowBVMPrompt(true);
									setFocus('pre-oxygenate-bvm-header');
								} 
								else if(selection === 2) {
									setShowBVMPrompt(true);
									setShow100Prompt(true);
									setFocus('pre-oxygenate-100-header');
								} else {
									props.parameters.onDoneClicked(selection);
								}
								
							}
						}} />
					</div>
				</div>
			</div> : 
				<div style={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: '1000px',
					height: '500px',
					border: '3px solid rgb(192, 161, 6)',
					backgroundColor: 'rgb(36, 36, 36)',
					pointerEvents: 'all'
				}}>
					{show100Prompt ? <div>
						<p className='title-font' style={{
						textAlign: 'center',
						margin: '0',
						fontSize: '32pt',
						fontWeight: 'normal'
					}} tabIndex={0} id="pre-oxygenate-100-header">Are you sure you want the 100% non-Rebreather mask?</p>

					<div style={{
						position: 'absolute',
						top: '80px',
						left: '50%',
						width: '100%',
						transform: 'translate(-50%, 0)'
					}}>
						<p className='title-font' style={{
							textAlign: 'center',
							margin: '30px',
							fontSize: '14pt',
							fontWeight: 'normal'
						}} tabIndex={0}>The use of the 100% non-Rebreather mask is not as effective as nasal oxygenation.</p>
					</div>
					<GeneralButtonWithText parameters={{
						text: 'Let me select a better choice.',
						ariaLbl: 'Let me select a better choice.',
						top: '160px',
						left: '100px',
						width: '190px',
						srcIdle: "./assets/images/pre-oxygenate/modal-option.png ",
						isDisabled: false,
						customImgStyle: {
						},
						customButtonStyle: {
						},
						customTextStyle: {
							fontSize: '20pt'
						},
						onClicked: () => {
							setShow100Prompt(false);
							setShowBVMPrompt(false);
							setFocus('pre-oxygenate-header')
						}
					}} />
					<GeneralButtonWithText parameters={{
						text: `No, I'd rather use the 100% non-rebreather mask`,
						ariaLbl: 'No, I\'d rather use the 100% non-rebreather mask',
						top: '310px',
						left: '100px',
						width: '190px',
						srcIdle: "./assets/images/pre-oxygenate/modal-option.png ",
						isDisabled: false,
						customImgStyle: {
						},
						customButtonStyle: {
						},
						customTextStyle: {
							fontSize: '20pt'
						},
						onClicked: () => {
							props.parameters.onDoneClicked(selection);
						}
					}} />
					</div>:<div>
					<p className='title-font' style={{
						textAlign: 'center',
						margin: '0',
						fontSize: '40pt',
						fontWeight: 'normal'
					}} tabIndex={0} id='pre-oxygenate-bvm-header'>Are you sure you want BVM?</p>

					<div style={{
						position: 'absolute',
						top: '80px',
						left: '50%',
						width: '100%',
						transform: 'translate(-50%, 0)'
					}}>
						<p className='title-font' style={{
							textAlign: 'center',
							margin: '0',
							fontSize: '14pt',
							fontWeight: 'normal'
						}} tabIndex={0}>Please select ONE of the following options.</p>
						<p className='title-font' style={{
							textAlign: 'center',
							margin: '0',
							fontSize: '14pt',
							fontWeight: 'normal'
						}} tabIndex={0}>Nasal oxygenation increases your safe apnea time.</p>
					</div>
					<GeneralButtonWithText parameters={{
						text: 'Let me select a better choice.',
						ariaLbl: 'Let me select a better choice.',
						top: '160px',
						left: '100px',
						width: '190px',
						srcIdle: "./assets/images/pre-oxygenate/modal-option.png ",
						isDisabled: false,
						customImgStyle: {
						},
						customButtonStyle: {
						},
						customTextStyle: {
							fontSize: '20pt'
						},
						onClicked: () => {
							setShowBVMPrompt(false);
							setFocus('pre-oxygenate-header')
						}
					}} />
					<GeneralButtonWithText parameters={{
						text: `No, I'd rather occupy my hands`,
						ariaLbl: 'No, I\'d rather occupy my hands',
						top: '310px',
						left: '100px',
						width: '190px',
						srcIdle: "./assets/images/pre-oxygenate/modal-option.png ",
						isDisabled: false,
						customImgStyle: {
						},
						customButtonStyle: {
						},
						customTextStyle: {
							fontSize: '20pt'
						},
						onClicked: () => {
							props.parameters.onDoneClicked(selection);
						}
					}} /></div>}
					
				</div>
				}
		</div>
	);

};

const CustomPreOxygenateButton = (props: CustomPreOxygenateButtonConfig) => {
	return (
		<div style={{
			position: props.position.type ? props.position.type : 'relative',
			top: props.position.top,
			left: props.position.left,
			width: props.isLargeBg ? '300px' : '250px',
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'relative'
			}}>
				<GeneralButtonWithText parameters= {{
					text: '',
					ariaLbl: props.ariaLbl,
					top: '0px',
					left: '0px',
					isDisabled: false,
					width: '188px',
					srcIdle: './assets/images/pre-oxygenate/bttnLarge.png',
					srcHighlight: null,
					srcDisabled: null,
					customMainStyle: {
						// position: 'relative',
						// width: props.isFlipped ? '99px' : '129px',
						// transform: props.isFlipped ? 'scaleX(-1)' : 'scaleX(1)'
					},
					onClicked: () => {
						if(props.onClicked) {
							props.onClicked();
						}
					}
				}}/>
				
				<div style={{
					position: 'absolute',
					pointerEvents: 'none',
					width: '120px',
					right: props.isLargeBg ? '30px' : '20px',
					top: props.isLargeBg ? '29px' : '19px',
					height: '110px'
				}}>
					<div style={{
						position: 'relative',
						top: '50%',
						transform: 'translate(0, -50%)'
					}}>
						<p className='title-font' style={{
							textAlign: 'center',
							margin: '0',
							fontSize: '16pt',
							fontWeight: 'normal'
						}}>{props.text}</p>
					</div>
				</div>

				<div style={{
					position: 'absolute',
					height: '30px',
					width: props.sideImgWidth,
					left: '21px',
					top: props.isLargeBg ? '30px' : '18px'
				}}>
					<img style={{
						width: '100%'
					}} src={props.sideImgUrl} />
				</div>

				{props.isClicked ? <img style={{
					position: 'absolute',
					top: props.isLargeBg ? '26px' : '19px',
					right: props.isLargeBg ? '-26px' : ' -23px',
					width: props.isLargeBg ? '35px' : '30px',
					pointerEvents: 'none'
				}} src={"./assets/images/general/buttons/button_side_pointer.png"} /> : (null)}
			</div>
		</div>
	);

};

interface CustomPreOxygenateButtonConfig {
	text: string;
	ariaLbl: string;
	isClicked: boolean;
	isLargeBg: boolean;
	sideImgUrl: string;
	sideImgWidth: string;
	position: CustomPreOxygenateButtonPosition;
	onClicked?: () => void;
}

interface CustomPreOxygenateButtonPosition {
	type?: any;
	left: string;
	top: string;
}

export interface PreOxygenateOptionsUIConfig extends BaseConfig{
	onDoneClicked: (selection: number) => void;
	onCloseClicked?: () => void;
}

export default PreOxygenateOptionsUI;